import React from 'react';
import clsx from 'clsx';

const ProductCardPlaceholder = () => {
  return (
    <div className="skeleton flex flex-col">
      <div
        className={clsx(
          'flex',
          'bg-gray-100',
          'rounded-t',
          'aspect-square',
          'relative',
          'overflow-hidden'
        )}
      ></div>
      <div
        className={clsx(
          'flex-col',
          'flex',
          'flex-1',
          'rounded-b',
          'pt-1',
          'px-3',
          'pb-3',
          'border-solid',
          'border',
          'border-gray-100',
          'lg:pt-2',
          'lg:px-4',
          'lg:pb-4'
        )}
      >
        <div className="information">
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[80px]',
              'mb-2',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-xs',
              'mb-2',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[60%]',
              'mb-4',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
        </div>
        <div className="bottom mb-2">
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[100px]',
              'mb-2'
            )}
          >
            &nbsp;
          </div>
          <div
            className={clsx(
              'bg-gray-100',
              'rounded-sm',
              'max-w-[80px]',
              'mb-2',
              'text-sm'
            )}
          >
            &nbsp;
          </div>
        </div>
        <div className="flex flex-1 flex-col justify-end">
          <div className="mb-2 h-10 w-full rounded-sm bg-gray-100">
            &nbsp;
          </div>
          <div
            className={clsx('bg-gray-100', 'rounded-sm', 'max-w-[64px]')}
          >
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardPlaceholder;
